import React from 'react';
import { Container } from "../components"
import { useViewport } from "../utils"

const ContainerOnMobile = ({children, ...props}) => {
  const { isDesktop } = useViewport()

  return <>
    {
      !isDesktop ?
      <Container {...props}>
        {children}
      </Container> : children
    }
  </>
}

export default ContainerOnMobile
